import React from "react";
import CheckBox from "components/FormElements/CheckBox";

function CheckboxMetaProperty(props) {
    return <CheckBox name={props.name} />;
}

export default CheckboxMetaProperty;

export const Property = CheckboxMetaProperty;
export const Label = "Checkbox";
